import { Button, Stack, Text, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { useNavigate } from "@tanstack/react-router";

import { SaveRebindTruck, useGetDriverQuery, useGetTruckQuery, useSaveRebindTruckMutation } from "@/store/apis/nextcargo";
import { cn } from "@/utils";

type RebindTruckModalProps = {
  driverId: number;
  truck: {
    id: number;
  } & SaveRebindTruck["args"]["truck"];
};

export function RebindTruckModal({ id, context, innerProps }: ContextModalProps<RebindTruckModalProps>) {
  const navigate = useNavigate();
  const { driverId, truck } = innerProps;

  const { data: _driverData, isSuccess: isDriverSuccess, isLoading: isDriverLoading } = useGetDriverQuery({ id: driverId }, { skip: !driverId });
  const { data: truckData, isSuccess: isTruckSuccess, isLoading: isTruckLoading } = useGetTruckQuery({ id: truck.id }, { skip: !truck.id });
  const [trigger, { isLoading: isRebindLoading }] = useSaveRebindTruckMutation();

  const isLoading = isDriverLoading || isTruckLoading || isRebindLoading;

  const handleConfirm = async () => {
    if (!isDriverSuccess || !isTruckSuccess) return;

    const { error } = await trigger({
      driver: {
        id: driverId
      },
      truck: {
        licensePlate: truck.licensePlate!,
        renavam: truck.renavam!,
        implementType: truck.implementType!,
        shaftQuantity: truck.shaftQuantity!,
        grossCapacity: truck.grossCapacity!,
        netCapacity: truck.netCapacity!,
        owner: truckData.owner!,
        vehicleModel: { id: truck.vehicleModel.id },
        company: { id: truckData.company.id }
      }
    });

    if (!error) {
      context.closeAll();
      navigate({ to: "/app" });
      return;
    }
  };

  const handleDecline = () => {
    context.closeModal(id);
  };

  return (
    <Stack>
      <Title order={3} c="red">
        Atenção!
      </Title>

      <Stack gap="xs">
        <Text>O caminhão selecionado já está vinculado a outro motorista. Deseja desvincular o caminhão do motorista atual e vinculá-lo ao motorista selecionado?</Text>

        <div className={cn("grid! grid-cols-1 gap-1! md:grid-cols-2")}>
          <Button onClick={handleDecline} color="red" disabled={isLoading}>
            Cancelar
          </Button>

          <Button onClick={handleConfirm} color="green" loading={isLoading}>
            Confirmar
          </Button>
        </div>
      </Stack>
    </Stack>
  );
}
